import React from 'react'
import { connect } from 'react-redux'
import { getCustomer } from '../redux/actions'
import ButtonToggle from '../elements/ButtonToggle'
import PaymentMethodCardForm from '../forms/PaymentMethodCardForm'
import PaymentMethodDebitForm from '../forms/PaymentMethodDebitForm'
import globals from '../globals'

class PaymentMethodContainer extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            active: ''
        }
    }

    handleClick (event, active, formRef) {
        event.preventDefault()
        this.setState({ active: active }, () => {
            this.reset()
            formRef.style.display = 'block'
        })
    }

    handleSuccess (type) {
        this.props.getCustomer()
        globals.pushEvent('ChangePaymentMethodSubmit', { type: type })
    }

    reset () {
        this.formCredit.style.display = 'none'
        this.formDebit.style.display = 'none'
    }

    render () {
        return (
            <div>
                {this.props.children}

                <div className='w-100 my-4 text-center'>
                    <ButtonToggle
                        title='Add credit/debit card'
                        active={this.state.active === 'credit'}
                        className='m-2'
                        handleClick={event => this.handleClick(event, 'credit', this.formCredit)}
                    />
                    <ButtonToggle
                        title='Add direct debit details'
                        active={this.state.active === 'debit'}
                        className='m-2'
                        handleClick={event => this.handleClick(event, 'debit', this.formDebit)}
                    />
                </div>

                <div ref={el => this.formCredit = el} style={{ display: 'none' }}>
                    <PaymentMethodCardForm active={this.state.active} handleSuccess={() => this.handleSuccess('credit')} />
                </div>
                <div ref={el => this.formDebit = el} style={{ display: 'none' }}>
                    <PaymentMethodDebitForm active={this.state.active} handleSuccess={() => this.handleSuccess('debit')} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, { getCustomer })(PaymentMethodContainer)



// WEBPACK FOOTER //
// ./resources/js/forms/PaymentMethodContainer.js